import { PageHero } from "@/components/site/PageHero";
import { Reveal } from "@/components/site/Reveal";
import { GlobalMap, Initiatives, CtaBand } from "@/components/site/Sections";
import { IMAGES, PRIORITIES } from "@/components/site/data";

export default function GlobalSourcing() {
  return (
    <>
      <PageHero overline="Global Sourcing" title="International Products. Strategic Selection." image={IMAGES.trade}>
        <p>
          RSC Imports develops supplier relationships across multiple international sourcing
          regions.
        </p>
        <p>
          Our objective is to identify manufacturers and producers whose products demonstrate strong
          potential for the consumer markets we serve.
        </p>
      </PageHero>

      <GlobalMap />

      <section data-testid="sourcing-priorities-section" className="py-24 md:py-32 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <Reveal>
            <p className="text-xs md:text-sm uppercase tracking-[0.25em] font-semibold text-[#BFA26F] mb-4" data-testid="overline-sourcing-priorities">
              Current International Sourcing Priorities
            </p>
            <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-medium leading-tight text-[#111413] max-w-3xl mb-16">
              Our Core Sourcing Categories.
            </h2>
          </Reveal>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 border-t border-l border-[#0D2B1E]/10" data-testid="priorities-grid">
            {PRIORITIES.map((p, i) => (
              <Reveal key={p} delay={i * 0.05} className="border-b border-r border-[#0D2B1E]/10">
                <div className="p-6 md:p-8 h-full bg-[#FBF9F6]/60 hover:bg-[#FBF9F6] transition-colors duration-300 flex items-start gap-4">
                  <span className="mt-1.5 h-1 w-4 bg-[#BFA26F] shrink-0" />
                  <p className="text-sm font-medium tracking-wide text-[#111413] uppercase">{p}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <Initiatives />

      <CtaBand
        title="Introduce Your Products."
        text="RSC Imports continuously reviews new manufacturers, producers, brands and product categories."
        buttonLabel="Submit Your Products"
        to="/partner"
      />
    </>
  );
}
